import React from 'react';
import PointAddress from "../pointAddress";
import InfoSection from "../infoSection";
import TotalBlock from "../totalBlock";
import TariffSection from "../tariffSection";

const ParcelInfoTab = ({form: parcel, errors, companyData, options}) => {
    const values = (name) => {
        const type = (name === 'delivery') ? 'recipient' : 'sender';
        return {
            [`${name}ContactPersonName`]: parcel[`${type}Name`],
            [`${name}Company`]: parcel[`${type}CompanyName`],
            [`${name}PhoneNumber`]: parcel[`${type}ContactInfo`],
            [`${name}Additional`]: parcel[`${type}Additional`],
        }
    }

    const form = {
        ...parcel,
        ...values('delivery'),
        ...values('shipment'),
        documentWeight: (parcel.parcelType === options.parcelTypes.parcelTypeDoc) && parcel.weight,
        cargoWeight: (parcel.parcelType !== options.parcelTypes.parcelTypeDoc) && parcel.weight,
        cargoPackages: parcel.packagesCount,
        cargoVolume: parcel.volume,
    };

    return (
        <div className='parcel-info'>
            <div className='parcel-info__from-to'>
                <PointAddress
                    isFrom
                    form={form}
                    errors={errors}
                />
                <PointAddress
                    form={form}
                    errors={errors}
                />
            </div>
            <div className='parcel-info__from-to'>
                <InfoSection
                    isDoc={form.parcelType === options.parcelTypes.parcelTypeDoc}
                    errors={errors}
                    form={form}
                    companyData={companyData}
                    total={<TotalBlock
                        isCreate={false}
                        noLabel
                        form={form}
                        isDoc={form.parcelType === options.parcelTypes.parcelTypeDoc}
                        isPallets={form.parcelType === options.parcelTypes.parcelTypePallets}
                    />}
                />
                <TariffSection
                    errors={errors}
                    form={form}
                    options={options}
                    disabled
                />
            </div>
        </div>
    );
};

export default ParcelInfoTab;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/tabs/parcelInfoTab.jsx